import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { pageRoutes } from '../../constants/routes';
import { Button } from '../../components/onboarding/Button';
import { PlatformRole, formatPlatformRoleLabel } from '../../types/onboarding';
import OnboardingSubHeader from '../../components/onboarding/OnboardingSubHeader';
import { OnboardingSurface } from '../../components/onboarding/Surface';

interface AccessDeniedProps {
  title: string;
  message: string;
  currentRole?: PlatformRole;
  roleHintByRole?: Partial<Record<PlatformRole, string>>;
}

const ROLE_SCOPE_HINT: Partial<Record<PlatformRole, string>> = {
  admin: ' (Global scope)',
  developer: ' (Project-level scope)',
  maintainer: ' (Organization-level scope)',
};

function AccessDenied({
  title,
  message,
  currentRole,
  roleHintByRole,
}: AccessDeniedProps) {
  const navigate = useNavigate();
  const scopeHint = currentRole ? ROLE_SCOPE_HINT[currentRole] ?? '' : '';
  const roleHint = currentRole ? roleHintByRole?.[currentRole] : undefined;

  return (
    <>
      <OnboardingSubHeader title={title} showBackButton />
      <main className="bg-surface-muted px-8 py-8">
        <div className="max-w-2xl mx-auto">
          <OnboardingSurface className="p-8 text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-8 h-8 text-red-500" />
            </div>
            <h2 className="text-xl font-bold text-brand mb-2">
              Access Denied
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            {currentRole && (
              <p className="text-sm text-gray-500 mb-2">
                Your current role:{' '}
                <span className="font-semibold">
                  {formatPlatformRoleLabel(currentRole)}
                </span>
                {scopeHint}
              </p>
            )}
            {roleHint && (
              <p className="text-sm text-gray-500 mb-6">{roleHint}</p>
            )}
            <Button
              variant="outline"
              onClick={() => navigate(pageRoutes.onboarding)}
            >
              Go Back
            </Button>
          </OnboardingSurface>
        </div>
      </main>
    </>
  );
}

export default AccessDenied;
